import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

/** Xem chứng từ ngay trong app (ảnh / PDF nhúng), không mở tab mới. */
function XemChungTuTrongApp({ url, tieuDe }) {
  if (!url) {
    return <MDAlert color="warning">Không có chứng từ đính kèm.</MDAlert>;
  }

  const laPdf = /\.pdf($|\?)/i.test(url) || url.includes("/raw/upload/");
  const laAnh = !laPdf;

  return (
    <MDBox>
      {tieuDe && (
        <MDTypography
          variant="caption"
          color="text"
          textTransform="uppercase"
          display="block"
          mb={0.75}
        >
          {tieuDe}
        </MDTypography>
      )}
      {laPdf ? (
        <MDBox
          component="iframe"
          src={url}
          title="Chứng từ thanh toán"
          sx={{
            width: "100%",
            height: { xs: 360, sm: 480 },
            border: 0,
            borderRadius: 1,
            bgcolor: "grey.100",
          }}
        />
      ) : (
        <MDBox
          component="img"
          src={url}
          alt="Chứng từ thanh toán"
          sx={{
            display: "block",
            width: "100%",
            maxHeight: { xs: 420, sm: 560 },
            objectFit: "contain",
            borderRadius: 1,
            bgcolor: "grey.100",
          }}
        />
      )}
    </MDBox>
  );
}

XemChungTuTrongApp.propTypes = {
  url: PropTypes.string,
  tieuDe: PropTypes.string,
};

XemChungTuTrongApp.defaultProps = {
  url: null,
  tieuDe: "Chứng từ thanh toán",
};

export default XemChungTuTrongApp;
